import FixtureSummary from "./FixtureSummary";
export default FixtureSummary;
